import { Injectable } from '@angular/core';
import { ParagraphFormContentData, ParagraphFormContentItemData } from '@generated/content';
import { CmsComponentConfig, CmsComponentNodeData, CmsFixes, LinkObject, TGtmEvent } from '@models/interfaces';
import { Form } from '@interfaces/config/cms-components/form-config';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';

@Injectable({
  providedIn: 'root',
})
export class FormComponentResolver extends BaseComponentResolver {
  static override instance: FormComponentResolver;
  protected override nodePageData: CmsComponentNodeData[] = [];
  private readonly componentType = Form.TypeEnum;

  static getInstance(): FormComponentResolver {
    return (FormComponentResolver.instance ||= new FormComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphFormContentData,
    componentNodePageData: CmsComponentNodeData[] = []
  ): CmsComponentConfig<Form.ComponentConfig> {
    this.nodePageData = componentNodePageData;

    let gtmEvent: TGtmEvent = null;

    let emailRecepients:any;
    if (node.attributes.field_datalayer_event) {
      gtmEvent = this.parseDataLayerString(node.attributes.field_datalayer_event) as TGtmEvent;
      emailRecepients = this.getEmailRecepients(node.attributes.field_datalayer_event);
    }

  
    return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        formId: node.attributes.field_eloqua_form_id,
        formHeadline: this.hyphenate(node.attributes?.field_form_headline),
        headline: this.hyphenate(node.attributes.field_headline_fcontent),
        paragraphs: this.resolveSidebarParagraphs(node),
        gtmEvent,
        emailRecepients
      },
    };
  }

  private resolveSidebarParagraphs(node: ParagraphFormContentData): Form.SideContentItemConfig[] {
    const contentItemData = node.relationships?.field_content_items?.data;

    if (!contentItemData?.length) {
      return [];
    }

    const contentItems: ParagraphFormContentItemData[] = contentItemData.map(({ type, id }) =>
      this.getNode<ParagraphFormContentItemData>(id, type)
    );

    return contentItems.map(item => {
      let link: LinkObject = null;

      if (item.attributes.field_link_fcontent_item) {
        link = {
          href: item.attributes.field_link_fcontent_item.url,
          label: this.hyphenate(item.attributes.field_link_fcontent_item.title),
        };
      }

      return {
        headline: this.hyphenate(item.attributes.field_headline_fcontent_item),
        content: this.hyphenate((item.attributes.field_body_fcontent_item as CmsFixes.CmsFreetextObject)?.processed),
        link,
        imageNodeId: item.relationships?.field_media_mediabox?.data?.id ?? null,
      };
    });
  }

  private parseDataLayerString(input: string): TGtmEvent {
    try {
      input = input.replaceAll(/'/g, '"');
      return JSON.parse(input) as TGtmEvent;
    } catch (error) {
      console.warn('[FORM_RESOLVER]: unable to parse DataLayer string ', error);
      return null;
    }
  }
  private getEmailRecepients(input:string) : any{
    try {
      input = input.replaceAll(/'/g, '"');
      return JSON.parse(input).emailRecepients;
    } catch (error) {
      console.warn('[FORM_RESOLVER]: unable to parse DataLayer string ', error);
      return null;
    }
  }
}
